var site = site || {};
(function ($) {
  site.EDD = site.EDD || {};

  //Function to display Estimated Delivery Date Message
  site.EDD.showEstimatedDeliveryDate = function(args) {

      //Show EDD info for US locale alone
      var estimated_delivery_date = $('.edd');
      if( estimated_delivery_date.length == 0 ) {
          return false;
      }
      estimated_delivery_date.hide();

      if( generic.cookie("LOCALE") == "en_US" ) {
          //Show EDD info only for shoppable SKUs
          if(args.isShoppable) {
              estimated_delivery_date.removeClass("hide");
              estimated_delivery_date.show();
              site.EDD.getEstimatedDeliveryDate();
          }
      }
  };

  site.EDD.getEstimatedDeliveryDate = function() {
      var edd_containers = $('.edd .edd_info');
      //JSON request should be made only once for better site performance
      if( !edd_containers[0].hasAttribute("data-ticker-id") ) {
          edd_containers.hide();
          edd_containers.attr("data-ticker-id", 0);
          generic.jsonrpc.fetch({
              method: 'address.estimateDeliveryDateSPP',
              params: [],
              onSuccess: function(jsonRpcResponse) {
                  var getEddInfo = jsonRpcResponse.getValue();
                  var need_it;
                  var order_within;

                  site.EDD.units = { hour : $('.edd .edd_hour_unit').text(),
                                     minute : $('.edd .edd_minutes_unit').text(),
                                     day : $('.edd .edd_days_unit').text(),
                                     tomorrow : $('.edd .edd_tomorrow_unit').text() };


                  if( getEddInfo.tomorrow )  { //Ex: tomorrow, Wednesday, August 13
                      need_it = site.EDD.units.tomorrow + ", " +
                                getEddInfo.need_on_day_name + ", " +
                                getEddInfo.need_on_month + " " +
                                getEddInfo.need_on_day;
                  } else { //Ex: Wednesday, August 13
                      need_it = getEddInfo.need_on_day_name + ", " +
                                getEddInfo.need_on_month + " " +
                                getEddInfo.need_on_day;
                  }

                  if( getEddInfo.order_by_days == 0 ) { //Ex: 13h 10min
                      order_within = getEddInfo.order_by_hours + site.EDD.units.hour + " " +
                                     getEddInfo.order_by_mins + site.EDD.units.minute;
                  } else { //Ex: 1d 13h 10min
                      order_within = getEddInfo.order_by_days + site.EDD.units.day + " " +
                                     getEddInfo.order_by_hours + site.EDD.units.hour + " " +
                                     getEddInfo.order_by_mins + site.EDD.units.minute;
                  }

                  //EDD Header
                  var edd_header = $('.edd .show_more');
                  edd_header.find('.when_you_need_it').html(need_it);
                  edd_header.off().on('click', function(event) {
                      event.preventDefault();
                      $(this).hide();
                      edd_containers.show(); //Hide the header and show the content
                  });
                
                  var edd_copy = $('.edd .edd_info p.copy');
                  edd_copy.attr({ "data-order-by-days" : getEddInfo.order_by_days,
                                  "data-order-by-hours" : getEddInfo.order_by_hours,
                                  "data-order-by-mins" : getEddInfo.order_by_mins });

                  var know_more_about_edd = $('.edd .edd_info .know_more');
                  edd_copy.find('.need_on').html(need_it);
                  edd_copy.find('.order_within').html(order_within);

                  know_more_about_edd.off().on('click', function(event) {
                      event.preventDefault();
                      $.colorbox({
                          html: $('.edd .what_is_edd').html(),
                          className: 'colorbox_edd_know_more',
                          fixed: 'true',
                          maxWidth: '600px',
                          maxHeight: '400px'
                      });
                  });

                  //Update the ticker every minute
                  var ticker_id = setInterval(site.EDD.updateEstimatedDeliveryDate, 60000);
                  edd_containers.attr("data-ticker-id", ticker_id);
              },
              onFailure: function(jsonRpcResponse) {
                  console.log('Failed to get EDD info');
              }
          });
      }
  };

  //Function to update the EDD ticker every minute
  site.EDD.updateEstimatedDeliveryDate = function() {
      var edd_copy = $('.edd .edd_info p.copy');
      var days = edd_copy.attr("data-order-by-days");
      var hours = edd_copy.attr("data-order-by-hours");
      var mins = edd_copy.attr("data-order-by-mins");
      var order_within = $('.edd .edd_info p.copy .order_within');

      if( mins == 0 && hours == 0 && days == 0) {
          //All of the datetime parts are zero, so do a JSON call to get updated information
          var edd_containers = $('.edd .edd_info');
          clearInterval(edd_containers.attr("data-ticker-id"));
          edd_containers.removeAttr("data-ticker-id");
          site.EDD.getEstimatedDeliveryDate();
          return;
      }

      if( mins > 0 ) {
          mins = mins - 1;
      } else if( hours > 0 ) {
          hours = hours - 1;
          mins = 59;
      } else if( days > 0 ) {
          days = days - 1;
          hours = 23;
          mins = 59;
      }

      edd_copy.attr({ "data-order-by-days" : days,
                      "data-order-by-hours" : hours,
                      "data-order-by-mins" : mins });

      //Refresh the EDD time part
      if(days == 0) {
          order_within.html(hours + site.EDD.units.hour + " " + mins + site.EDD.units.minute);
      } else {
          order_within.html(days + site.EDD.units.day + " " + hours + site.EDD.units.hour + " " + mins + site.EDD.units.minute);
      }
  };

  //Function to display Delivery details popup similar to checkout viewcart page's popup
  $('#delivery_info a').click(function(){
      generic.overlay.launch({
          content: $('.order_arrival_details_overlay').html(),
          includeBackground: true,
          cssClass: 'edd_popover',
          lockPosition: true,
          center: true, // one line required set
      });
  });
})(jQuery);

